<template>
  <div>
    <l-map ref="thePickerMap"
    :zoom.sync="currentZoom"
    :options="mapOptions"
    :center="center"
    :min-zoom="minZoom"
    :max-zoom="maxZoom"
    :bounds.sync="bounds"
    style="height: 300px; width: 100%;"
    @ready="emitReady"
    @click="pickPlace($event.latlng.lat, $event.latlng.lng)"
    >
      <l-tile-layer
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        layer-type="base"
        :options="tileProvider.options"
        v-if="tileProvidersReady"
      />
      <l-control-zoom :position="zoomPosition" />
      <l-control-attribution
        :position="attributionPosition"
        prefix="Moova"
      />
      <l-control-scale position="bottomright" :imperial="imperial" />

      <l-marker
        v-for="marker in markers"
        :key="marker.id"
        :lat-lng="[marker.lat, marker.lng]"
        :visible="true"
        :draggable="false"
        img
      >
        <l-icon
          :iconUrl="require('leaflet/dist/images/marker-icon.png')"
        >
        </l-icon>
      </l-marker>
    </l-map>
    <form @submit.prevent="emitPlacePicked" class="my-3">
      <div class="form-group col-sm-12" v-if="hasReference">
        <label for="reference" v-translate>Place Reference</label>
        <div class="input-group">
          <b-form-textarea
            id="reference"
            v-model="reference"
            rows="2"
            max-rows="3"
          ></b-form-textarea>
        </div>
        <b-form-text v-translate>Please add a brief description of the place.</b-form-text>
      </div>
      <div class="form-group col-sm-12">
        <b-button variant="primary" type="submit" :disabled="!this.markers[0]">
          <translate>Confirm Place</translate>
        </b-button>
        <b-button variant="secondary" @click.prevent="emitCancel">
          <translate>Cancel</translate>
        </b-button>
      </div>
    </form>
  </div>
</template>
<script>
import AddressMixins from '@/mixins/address.mixin.js'
import {
  LMap,
  LTileLayer,
  LMarker,
  LControlZoom,
  LControlAttribution,
  LControlScale,
  LControlLayers,
  LControl,
  LIcon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  name: 'PlacePicker',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    LControlLayers,
    LControl,
    LIcon
  },
  data() {
    return {
      reference: '',
      icon: null,
      places: [],
      currentPlace: null,
      map: null,
      mapReady: false,
      center: [-34.6158036, -58.5035093],
      opacity: 1,
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        zoomSnap: true
      },
      currentZoom: this.zoom || 11,
      minZoom: 1,
      maxZoom: 18,
      zoomPosition: 'topleft',
      layersPosition: 'topright',
      attributionPosition: 'bottomright',
      imperial: false,
      markers: [],
      bounds: null,
      fitted: false,
      tileProviders: this.$appConfig.maps.providers,
      tileProvidersReady: false
    }
  },
  props: {
    geolocate: {
      type: Boolean,
      default: false
    },
    fitOnce: {
      type: Boolean,
      default: false
    },
    fitAlways: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      default: 11
    },
    centerMap: {
      type: Boolean,
      default: false
    },
    hasReference: {
      type: Boolean,
      default: false
    }
  },
  mixins: [AddressMixins],
  created() {
    this.checkMapProviders()
  },
  methods: {
    pickPlace(lat, lng) {
      this.center = [lat, lng]
      this.markers = [{
        id: '0',
        lat,
        lng,
        icon: 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png',
        x: 10,
        y: 10
      }]
    },
    async emitPlacePicked() {
      await this.checkPlaceByCoords(this.markers[0].lat, this.markers[0].lng)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.theCheckedAddress.reference = this.reference
          this.$emit('placePicked', this.theCheckedAddress)
        }
      })
    },
    emitCancel() {
      this.$emit('cancel')
    },
    emitReady() {
      this.map = this.$refs.thePickerMap.mapObject
      this.map.on('popupclose', () => this.emitCourier(null))
      this.mapReady = true
      this.$emit('ready', true)
      setTimeout(function () {
        this.map.invalidateSize()
      }.bind(this), 100)
    },
    checkMapProviders() {
      if (this.$route.name === 'external_shipping_with_hash' || this.$route.name === 'external_shipping_with_hash_hack') {
        this.$http.get(this.tileProviders.find(x => x.name === 'Mapbox').testTile)
          .then(() => {
            this.tileProviders[this.tileProviders.findIndex(x => x.name === 'Mapbox')].visible = true
            this.tileProvidersReady = true
          }, e => {
            console.log(e)
            this.$root.$children[0].$refs.simplert.justCloseSimplert()
            this.$http.get(this.tileProviders.find(x => x.name === 'CartoDB').testTile)
              .then(() => {
                this.tileProviders[this.tileProviders.findIndex(x => x.name === 'CartoDB')].visible = true
                this.tileProvidersReady = true
              }, e => {
                this.$root.$children[0].$refs.simplert.justCloseSimplert()
                console.log(e)
                this.tileProviders[this.tileProviders.findIndex(x => x.name === 'OpenStreetMap')].visible = true
                this.tileProvidersReady = true
              })
          })
      } else {
        this.$http.get(this.tileProviders.find(x => x.name === 'Mapbox').testTile)
          .then(() => {
            this.tileProviders[this.tileProviders.findIndex(x => x.name === 'Mapbox')].visible = true
            this.tileProvidersReady = true
          }, e => {
            console.log(e)
            this.$root.$children[0].$refs.simplert.justCloseSimplert()
            this.$http.get(this.tileProviders.find(x => x.name === 'CartoDB').testTile)
              .then(() => {
                this.tileProviders[this.tileProviders.findIndex(x => x.name === 'CartoDB')].visible = true
                this.tileProvidersReady = true
              }, e => {
                this.$root.$children[0].$refs.simplert.justCloseSimplert()
                console.log(e)
                this.tileProviders[this.tileProviders.findIndex(x => x.name === 'OpenStreetMap')].visible = true
                this.tileProvidersReady = true
              })
          })
      }
    }
  }
}
</script>
